import { useFormikContext } from 'formik';
import React from 'react';
import { Card } from 'react-bootstrap';

import { ButtonClear, ButtonSearch, FlexRow } from './../index';

type Props = {
  /** Title of form */
  readonly title: string;
  /** Optional title suffix muted */
  readonly idx?: number;
  /** Optional onReturn event, enabled only if form is not dirty */
  readonly onReturn?: () => void;
  readonly onClear?: () => void;
};

const FormFilterHeader = ({ title, idx = null, onReturn = null, onClear = null }: Props) => {
  const { isValid, setFieldValue, values } = useFormikContext();
  // Reset filter values at any point
  const resetAll = () => {
    if (typeof onClear === 'function') {
      onClear();
    }
    // Clear Values
    Object.keys(values).forEach((k) =>
      k.includes('Date') ? setFieldValue(k, null) : setFieldValue(k, ''),
    );
  };
  return (
    <Card.Header className="form-filter-card-header">
      <Card.Title className="form-filter-header-title">
        <FlexRow>
          <h5>{title}</h5>
          <div>
            <ButtonSearch disabled={!isValid} type="submit" size="sm" className="me-2" />
            <ButtonClear onClick={resetAll} size="sm" />
          </div>
        </FlexRow>
      </Card.Title>
    </Card.Header>
  );
};

export default React.memo(FormFilterHeader);
